const url = {
  development: 'http://127.0.0.1:8000',
  production: 'http://programalaplaza.medialab-prado.es/backend'
  // production: 'http://127.0.0.1/backend'
}

//
const config = {
  environment: process.env.NODE_ENV,
  baseurl: url.production
}

config.baseurl = url[config.environment]

// console.log(config)

export default config



// WEBPACK FOOTER //
// ./src/api/config.js